export default __webpack_public_path__ + "static/media/client49.421ad83e.png";